import styled from 'styled-components';

const PanelContainer = styled.div<{ $thinner?: boolean }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: ${(props) => (props.$thinner ? '690px' : '1000px')};
	max-width: 95vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	background-color: #111314;
	border-radius: 10px;
	overflow: visible;
	user-select: none;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
`;

export { PanelContainer };
